import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { DefaultFontStyles } from "@fluentui/react/lib/Theme";

import { flex } from "Utils/Styles";
import { headerHeight } from "./Header/UseHeaderStyles";

const classNames = {
  root: `App`,
  header: `AppHeader`,
  main: `AppMain`,
  error: `AppError`,
  noauth: `AppNoAuth`
};

export function useAppStyles() {
  // NOTE: THEMING DOES NOT WORK AT THIS COMPONENT LEVEL
  // BUT THEMING WORKS IN LOWER LEVEL COMPONENTS
  const styleSet = useMemo(
    () => mergeStyleSets({
      header: [classNames.header, {}],
      main: [
        classNames.main,
        {
          height: `calc(100vh - ${headerHeight}px - 42px)`,
          overflow: `hidden`
        }
      ],
      error: [
        classNames.error,
        {
          padding: 20
        }
      ],
      noauth: [
        classNames.noauth,
        {
          ...flex,
          ...DefaultFontStyles.mediumPlus,
          alignItems: `center`,
          height: `100%`,
          justifyContent: `center`,
          padding: 50,
          width: `100%`
        }
      ]
    }),
    []
  );

  return styleSet;
}
